import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import labels from "emun.customer/_labels";
import salesrepConfig from 'emun.salesrep/salesrep.config'

export default class CustomerVendorsShippedController {
	constructor() {
		let $ctrl = this;
		basicController($ctrl);
		$ctrl.mode = "list";
		$ctrl.total = 0;
		$ctrl.colors = salesrepConfig.chartColors;
		$ctrl.chartOptions = {
			maintainAspectRatio: false,
			legend: {
				display: true,
				labels: {
					boxWidth: 5,
					fontSize: 10
				}
			},
			elements: {
				rectangle: {
					borderWidth: 1
				}
			},
			tooltips: {
				enabled: true,
				callbacks: {
					label: function (tooltipItem, data) {
						var label = data.labels[tooltipItem.index];
						let datasetLabel =
							data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
						return (
							label +
							": $" +
							datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
							"  (" +
							Math.round((datasetLabel / $ctrl.total) * 100) +
							"%)"
						);
					}
				}
			}
		};
		$ctrl.labels = labels;
		$ctrl.vendorTotals = [];
		$ctrl.vendorTotals2 = [];
		$ctrl.ytdTotal = 0;
		$ctrl.lytdTotal = 0;
		$ctrl.lytdSalesQuery = new AutoQuery({
			url:
				"QueryInvoiceDailyCustomerTotals.json?Fields=CustomerName&Sum=InvoiceTotal,InvoiceCount&dateRange=LYTD&GroupBy=VendorId,VendorName",
			criteria: {
				customerId: $ctrl.customer.id,
				repGroupName: $ctrl.repGroup || undefined
			},
			autoLoad: false,
			onLoaded(args) {
				if (args.total > 0) {
					args.results.forEach(function (v) {
						$ctrl.lytdTotal += Math.round(v.sumInvoiceTotal);
					});
					console.debug("$ctrl.lytdTotal", $ctrl.lytdTotal);
					args.results.forEach(function (v) {
						$ctrl.vendorTotals.forEach(function (obj) {
							if (v.vendorName === obj.label) {
								obj.lytd = Math.round(v.sumInvoiceTotal);
								var percent = Math.round((obj.ytd / obj.lytd) * 100);
								if (obj.lytd === 0) { percent = 100; }
								if (percent < 100) {
									obj.percent = 100 - percent;
									obj.trend = 'down';
								} else if (percent > 100) {
									obj.percent = percent - 100;
									obj.trend = 'up';
								} else {
									obj.percent = 100;
									obj.trend = 'neutral';
								}
								obj.lytdVendorPercent = Math.round((v.sumInvoiceTotal / $ctrl.lytdTotal) * 100);
							}
						});
					});
				}
			}
		});

		$ctrl.ytdSalesQuery = new AutoQuery({
			url:
				"QueryInvoiceDailyCustomerTotals.json?Fields=CustomerName&Sum=InvoiceTotal,InvoiceCount&dateRange=YTD&GroupBy=VendorId,VendorName&customerId=" +
				$ctrl.customer.id,
			autoLoad: true,
			onLoaded(args) {
				$ctrl.chartLabels = [];
				$ctrl.chartData = [];
				if (args.total > 0) {
					args.results.forEach(function (v) {
						$ctrl.ytdTotal += Math.round(v.sumInvoiceTotal);
					});
					console.debug("$ctrl.ytdTotal", $ctrl.ytdTotal);
					args.results.forEach(function (v) {
						var obj = {
							label: v.vendorName,
							ytd: Math.round(v.sumInvoiceTotal),
							lytd: 0,
							percent: 100,
							trend: 'up',
							ytdVendorPercent: Math.round((v.sumInvoiceTotal / $ctrl.ytdTotal) * 100),
							lytdVendorPercent: 0
						};
						$ctrl.vendorTotals.push(obj);
						$ctrl.chartLabels.push(obj.label);
						$ctrl.chartData.push(Math.round(obj.ytd));
						$ctrl.total += obj.ytd;
					});
				}
				$ctrl.lytdSalesQuery.load();
			}
		});
	}
	
	downloadData() {
		let $ctrl = this;
		var itemsFormatted = [];

		var headers = {
			name: "Brand",
			ytd: "YTD",
			ytdVendorPercent: "YTD %",
			lytd: "LYTD",
			lytdVendorPercent: "LYTD %",
			percent: "Trend %",
		};

		// format the data
		$ctrl.vendorTotals.forEach((item) => {
			itemsFormatted.push({
				name: item.label.replace(/,/g, ''), // remove commas to avoid errors,
				ytd: item.ytd,
				ytdVendorPercent: item.ytdVendorPercent,
				lytd: item.lytd,
				lytdVendorPercent: item.lytdVendorPercent,
				percent: item.percent,
			});
		});

		var fileTitle = 'customer-vendor-totals';
		$ctrl.utils.exportCSVFile(headers, _.sortBy(itemsFormatted, 'name').reverse(), fileTitle);
	}

	isBusy() {
		const $ctrl = this;
		return $ctrl.lytdSalesQuery.isBusy() || $ctrl.ytdSalesQuery.isBusy();
	}
}
